import { defineStore } from "pinia";
import { useVideoStore } from "@/store/video";
import { loadVideoQuality, loadVolumeValue, setVideoQuality, setVolumeValue } from "@/utils/storage";

interface PlayerState {
  theaterMode: boolean;
  recId: string | null;
  pipModeEnabled: boolean;
  vrType: string | null;
  quality: string | number;
  volume: number;
  autoplay: boolean;
}

export const usePlayerStore = defineStore("player", {
  state: (): PlayerState => ({
    theaterMode: false,
    recId: null,
    pipModeEnabled: false,
    vrType: null,
    quality: loadVideoQuality() || "auto",
    volume: loadVolumeValue() !== null ? loadVolumeValue() : 1.0,
    autoplay: true,
  }),

  getters: {
    isTheaterMode: (state: PlayerState) => state.theaterMode,
    getRecommendationId: (state: PlayerState) => state.recId,
    isPipModeEnabled: (state: PlayerState) => state.pipModeEnabled,
    getVrType: (state: PlayerState) => state.vrType,
    getQuality: (state: PlayerState) => state.quality,
    getVolume: (state: PlayerState) => state.volume,
    isAutoplay: (state: PlayerState) => state.autoplay,
  },

  actions: {
    setTheaterMode({
      videoId,
      recId = null,
      vrType = null,
      autoplay = true,
    }: {
      videoId: number | null;
      recId?: string | null;
      vrType?: string | null;
      autoplay?: boolean;
    }) {
      const videoStore = useVideoStore();
      const activeVideoId = videoStore.getActiveVideo;

      if (activeVideoId !== videoId) {
        this.theaterMode = videoId !== null;
        this.recId = recId;
        this.autoplay = autoplay;
        this.vrType = vrType;

        videoStore.setActiveVideo(videoId);
      } else {
        this.setPipMode(false);
      }
    },
    setPipMode(value: boolean) {
      this.pipModeEnabled = value;
    },
    setQuality(quality: string | number) {
      setVideoQuality(quality);
      this.quality = quality;
    },
    setVolume(volume: number) {
      setVolumeValue(volume);
      this.volume = volume;
    },
  },
});
